import * as React from 'react';
export const evolveSvg = React.forwardRef(function evolveSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#016BF7',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm10.861 17.284 2.201.653c1.112 2.507 3.278 4.806 6.59 4.944 3.313.132 5.32-2.326 5.32-2.326l1.028.028v3.486H6.139l.055-1.597c4.369-1.514 4.667-5.188 4.667-5.188ZM6 16.91c.597-.729 4.667-3.048 9.465-.632 4.806 2.43 8.118.542 8.118.542l.271.514c-1.791 1.41-5.944 2.514-9.715.354-3.77-2.16-7.84-.403-7.84-.403L6 16.91Zm1.549-2.076c.597-.73 4.666-3.056 9.472-.625 4.798 2.43 8.11.541 8.11.541l.272.514c-1.792 1.403-5.945 2.507-9.715.348-3.771-2.16-7.84-.403-7.84-.403l-.3-.375ZM25.986 7.93v3.007h-.007l-1.215.07s-1.583-2.028-4.98-2.028c-3.395 0-5.583 2.777-5.812 3.451-1.764-.174-3.694.396-3.694.396S8.688 9.833 6.222 9.43v-1.5h19.764Z',
      fill: '#fff',
    }),
  );
});
evolveSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var evolve = {
  category: 'brand',
  colorable: false,
  name: 'evolve',
  svg: evolveSvg,
};
